import { DOCUMENT, isPlatformServer } from '@angular/common';
import {
  Injectable,
  Inject,
  Optional,
  inject,
  PLATFORM_ID
} from '@angular/core';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { Request } from 'express';
import { UAParser } from 'ua-parser-js';
import { toUrl } from '@veone/ngx-utilities/url';

@Injectable()
export class SsrRequestService {
  protected _platformId = inject(PLATFORM_ID);
  protected _document = inject(DOCUMENT);

  protected get _isPlatformServer(): boolean {
    return isPlatformServer(this._platformId);
  }

  constructor(@Optional() @Inject(REQUEST) private _request: Request | null) {}

  get request(): Request | null {
    return this._request;
  }

  get requestUrl(): URL | null {
    const request = this.request;
    return request
      ? toUrl(
          `${request.protocol}://${request.get('host')}${request.originalUrl}`
        )
      : null;
  }

  get requestBaseUrl(): URL | null {
    const request = this.request;
    return request
      ? toUrl(`${request.protocol}://${request.get('host')}`)
      : null;
  }

  get hostname(): string {
    if (this._isPlatformServer) {
      return this._request?.get('host')?.split(':')[0] ?? '';
    } else {
      return this._document.defaultView?.location.hostname ?? '';
    }
  }

  get rootDomainName(): string {
    const hostname = this.hostname;
    if (hostname) {
      const parts = hostname.split('.');
      return parts.length > 2 ? parts.slice(-2).join('.') : hostname;
    }
    return '';
  }

  isDesktop(): boolean | null {
    const userAgent = this._isPlatformServer
      ? this._request?.headers['user-agent']
      : navigator.userAgent;
    if (userAgent) {
      const parsedContent = new UAParser(userAgent);
      const deviceType = parsedContent.getDevice().type;
      return !['mobile', 'tablet', 'wearable', 'embedded'].includes(
        deviceType || ''
      );
    }
    return null;
  }
}
